import getDisplayName from "./getDisplayName";
import parseStringToOject from "./parseStringToOject";
import convertToGroupsList from "./convertToGroupsList";
import convertToAppDataFromContentful from "./convertToAppDataFromContentful";
import convertToAppData from "./convertToAppData";
import calculateClearFix from "./calculateClearFix";
import { getLocalStorage, setLocalStorage } from "./localStorage";
import {
  getFieldOptions,
  setFieldOptions,
  getFieldLabel
} from "./fieldOptions";
import convertFieldRules from "./convertFieldRules";
import convertFieldError from "./convertFieldError";

export default {
  getDisplayName,
  parseStringToOject,
  convertToGroupsList,
  convertToAppDataFromContentful,
  convertToAppData,
  calculateClearFix,
  getLocalStorage,
  setLocalStorage,
  getFieldOptions,
  setFieldOptions,
  getFieldLabel,
  convertFieldRules,
  convertFieldError
};
